/**
 * --------------------------------------------------------------------------
 * Basic Modules: SelectPlus.js
 * --------------------------------------------------------------------------
 */

//import Util from "./util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'selectPlus';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    width: null,
    infinite: false,
};

const Event = {
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    ACTIVE              : 'active',
};

const Selector = {
    TOGGLE              : `[data-toggle-select-plus]`,
};

const DataAttr = {
};

class SelectPlus {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this._element = element;
        this._config  = this._getConfig(config);

        this._numberOfOptions = $(this._element).find('option').length;

        this._buildControl();
        this._addEventListeners();
        this._init();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _init() {
        this._updateInput();
        this._updateButtonState(this._getSelectedIndex());
    }

    _updateInput() {
        let value = $(this._element).find('option:selected').text();
        this._input.val(value);
    }

    _updateButtonState(index) {

        if (this._config.infinite) return;

        this._nextButton.prop('disabled', false);
        this._prevButton.prop('disabled', false);

        if (this._numberOfOptions === index) {
            this._nextButton.prop('disabled', true);
        }
        else if (index === 0) {
            this._prevButton.prop('disabled', true);
        }
    }

    _getSelectedIndex() {
        return $(this._element).find('option:selected').index();
    }

    _buildControl() {

        $(this._element).hide();

        this._container = $('<div class="input-group input-select-plus"></div>');
        this._prevButton = $('<button type="button" class="btn btn-default"><span class="fa fa-arrow-left"></span></button>');
        this._nextButton = $('<button type="button" class="btn btn-default"><span class="fa fa-arrow-right"></span></button>');
        this._input = $('<input type="text" readonly class="form-control" style="cursor:pointer;">');

        // $(this._element).wrap('<div class="select-plus"></div>');
        // this._container = $(this._element).parent();

        this._container
            .append(this._prevButton)
            .append(this._input)
            .append(this._nextButton)
            .find('button').wrap('<span class="input-group-btn"></span>');

        if (this._config.width) {
            this._container.css('width', this._config.width);
        }

        this._container.insertAfter(this._element);
    }

    _addEventListeners() {
        this._prevButton.on(Event.CLICK, (event) => this._handlePrevButtonClick(event));
        this._nextButton.on(Event.CLICK, (event) => this._handleNextButtonClick(event));
        this._input.on(Event.CLICK, (event) => this._handleNextButtonClick(event))
    }

    _handlePrevButtonClick() {
        let index = this._getSelectedIndex();
        this._updateButtonState(index - 1);
        if (! this._config.infinite && -1 === index - 1) {
            return;
        }
        $(this._element).find('option').eq(index - 1).prop('selected', true);
        this._updateInput();
    }

    _handleNextButtonClick() {
        let index = this._getSelectedIndex();
        this._updateButtonState(index + 2);

        if (this._config.infinite) {
            if (index === (this._numberOfOptions - 1)) {
                index = -1;
            }
        }
        else if (this._numberOfOptions === index + 1) {
            return;
        }

        $(this._element).find('option').eq(index + 1).prop('selected', true);
        this._updateInput();
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        SelectPlus._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...typeof config === 'object' && config ? config : {},
                ...$this.data()
            };

            if (!data) {
                data = new SelectPlus(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = SelectPlus._jQueryInterface;
$.fn[NAME].Constructor = SelectPlus;


export default SelectPlus;
